export default __webpack_public_path__ + "static/media/PRINCEWILL SUIT - AI Automation Practice Lead.e2715a55.png";